// Only used as response type for overview lists (e.g. invoice overview)
import { Expose } from 'class-transformer';

export class FileNameModel {
  public id: number | null = null;

  @Expose({ name: 'filename' })
  fileName: '';
}
